import {ChangeEvent} from 'react';

export const getInputValue = (event: ChangeEvent): string => (event.target as HTMLInputElement).value;
export const getCheckboxValue = (event: ChangeEvent): boolean => (event.target as HTMLInputElement).checked;
